// 子账号管理 엑셀 내려받기·올리기 — 의존성 없는 순수 함수(검증: __tests__/coupassStaffExcel.test.mjs).
// 바꿀 수 있는 칸 = 姓名·备注·代号·分类. 账号 은 어느 계정인지 찾는 열(못 바꾼다). 状态·最近登录 은 보기용(올려도 무시).
// 실제 검증(계정이 있나·代号 중복·분류 목록)은 서버가 한다 — 여기서는 표를 { email, name?, memo?, code?, group? } 로 옮기기만 한다.

export const STAFF_EXCEL_COLUMNS = [
  { key: 'email', header: '账号(아이디)' },
  { key: 'name', header: '姓名(이름)', editable: true },
  { key: 'memo', header: '备注(메모)', editable: true },
  { key: 'code', header: '代号(담당자 코드)', editable: true },
  { key: 'group', header: '分类(분류)', editable: true },
  { key: 'status', header: '状态(상태)·不可修改(수정 안 됨)' },
  { key: 'lastLogin', header: '最近登录(최근 접속)·不可修改(수정 안 됨)' },
];

// 머리글 → 열 키. 전체 문구, 괄호 앞 중국어, 괄호 안 한국어 어느 것이든 받는다(공백 무시).
function headerKey(text) {
  const t = String(text == null ? '' : text).replace(/\s+/g, '');
  if (!t) return '';
  for (const c of STAFF_EXCEL_COLUMNS) {
    const h = c.header.replace(/\s+/g, '');
    const zh = h.split('(')[0];
    const ko = (h.match(/\(([^)]*)\)/) || [])[1] || '';
    if (t === h || t === zh || (ko && t === ko) || t.split('(')[0] === zh) return c.key;
  }
  return '';
}

export function staffToSheetRows(staff, statusText, timeText) {
  const head = STAFF_EXCEL_COLUMNS.map(c => c.header);
  const body = (staff || []).map(s => [
    s.email || '', s.name || '', s.memo || '', s.code || '', s.group || '',
    statusText ? statusText(s) : '', timeText ? timeText(s) : '',
  ]);
  return [head].concat(body);
}

/**
 * 엑셀 표(행 배열의 배열) → 일괄수정 요청 행.
 * @returns { rows, error } — error: 'no_header' | 'no_account_column' | 'no_editable_column' | ''
 *   그 열이 표에 없으면 그 칸은 행에 넣지 않는다(서버가 안 바꾼다). 칸이 비어 있으면 '' = 지우기.
 */
export function sheetRowsToUpdates(aoa) {
  const table = Array.isArray(aoa) ? aoa : [];
  // 머리글 줄 = 앞쪽 5줄 안에서 账号 열이 있는 첫 줄
  let headIdx = -1;
  let keys = [];
  for (let i = 0; i < Math.min(5, table.length); i++) {
    const ks = (table[i] || []).map(headerKey);
    if (ks.indexOf('email') !== -1) { headIdx = i; keys = ks; break; }
  }
  if (headIdx === -1) return { rows: [], error: table.length ? 'no_account_column' : 'no_header' };
  const editable = STAFF_EXCEL_COLUMNS.filter(c => c.editable).map(c => c.key);
  if (!keys.some(k => editable.indexOf(k) !== -1)) return { rows: [], error: 'no_editable_column' };

  const rows = [];
  for (let i = headIdx + 1; i < table.length; i++) {
    const line = table[i] || [];
    const row = {};
    let any = false;
    keys.forEach((k, j) => {
      if (k !== 'email' && editable.indexOf(k) === -1) return;
      const v = line[j] == null ? '' : String(line[j]).trim();
      if (v) any = true;
      row[k] = v;
    });
    if (!any) continue;               // 빈 줄은 건너뛴다
    rows.push(row);
  }
  return { rows, error: '' };
}

// 서버 오류 사유 → 화면 문구
export const BULK_ERROR_TEXT = {
  empty: '没有可修改的行(바꿀 줄이 없습니다)',
  too_many_rows: '一次最多300行(한 번에 300줄까지)',
  unknown_account: '账号不在列表中(목록에 없는 아이디)',
  duplicate_row: '同一账号出现两次(같은 아이디가 두 줄)',
  bad_code: '代号只能使用1~6位英文字母和数字(담당자 코드는 영문·숫자 1~6자)',
  unknown_group: '分类不在列表中，请先添加分类(분류 목록에 없음 — 먼저 분류를 추가)',
  code_exists: '代号重复(담당자 코드 중복)',
};
